<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  required="true"
  (valueChange)="onChanged($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-select
      name="ImportOrExportId"
      class="pricemodel"
      [group]="formGroup"
      textFieldName="Title"
      valueFieldName="Id"
      [dataList]="Data"
      [selectOnTab]="false"
      (valueChange)="valueChange($event)"
      userClass="select-md"
      [label]="'ClientApp.Projects.FrameWorkShell.Header.ImportExport.Type' | translate"></ssg-select>
    <!-- <ssg-input *ngIf="isUpload"
                [group]="formGroup"
                defaultHeight="50"
                [required]="true"
                name="PathUpload"
                [textType]="'file'"
                order="0"
                required="true"
                labletop="true"
                userClass= "select-lg"
                [isGetPath]="true"
                label="مسیر">
              </ssg-input> -->
    <ssg-input
      *ngIf="!isUpload"
      [group]="formGroup"
      defaultHeight="50"
      [required]="true"
      name="FilePath"
      [textType]="'file'"
      order="0"
      required="true"
      labletop="true"
      userClass="select-lg"
      (change)="handleUpload($event)"
      [label]="'ClientApp.Projects.FrameWorkShell.Header.ImportExport.Path' | translate">
    </ssg-input>
  </ng-container>
</dynamic-form>
